/* eslint-disable react/forbid-prop-types */
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { apiGetModel } from '../../useApiHook';
import { callAxios } from '../../../services/callAPIMiddleware';
import { mapOrgUnitOptions } from './../shared/mappingDtos';

export const useFetchOrgUnitOptions = (forceReload, onlyNotMapped = false, hasAny = false) => {
  const auth = useSelector(state => state.global.auth);
  const jwtToken = auth.jwtToken;
  const [state, setState] = useState({ response: null, isDataLoading: true, refresh: forceReload });
  const [error, setError] = useState(null);

  // Prepare api model and request call
  const dataModel = onlyNotMapped ? { RelevantDay: null, Type: 4 } : { RelevantDay: null };
  const model = apiGetModel('GetCurrentUserTeamsOptions', dataModel, forceReload);
  const setRequestResponse = response => setState({ ...state, response, isDataLoading: false, refresh: forceReload });

  useEffect(() => {
    if (jwtToken) {
      callAxios(auth, model.url, model.method, model.data)
        .then(result => setRequestResponse(result.data))
        .catch(ex => {
          setError(ex.mesage);
          setState({ ...state, isDataLoading: false });
        });
    }
  }, [jwtToken, model.url, model.reloadData]);

  // Returning strongly-type mappedDto object
  return {
    data: mapOrgUnitOptions(state.response, hasAny),
    isDataLoading: state.isDataLoading,
    auth,
    error,
  };
};

export const useFetchClinicianOptionsForUser = (model, forceReload) => {
  const auth = useSelector(state => state.global.auth);
  const jwtToken = auth.jwtToken;
  const [state, setState] = useState({ response: null, isDataLoading: true, refresh: forceReload });
  const [error, setError] = useState(null);

  // Prepare api model and request call
  const getModel = apiGetModel('GetCliniciansOptionsForUser', model, forceReload);
  const setRequestResponse = response => setState({ ...state, response, isDataLoading: false, refresh: forceReload });

  useEffect(() => {
    if (jwtToken) {
      callAxios(auth, getModel.url, getModel.method, getModel.data)
        .then(result => setRequestResponse(result.data))
        .catch(ex => {
          setError(ex.mesage);
          setState({ ...state, isDataLoading: false });
        });
    }
  }, [jwtToken, getModel.url, getModel.reloadData]);

  // Returning strongly-type mappedDto object
  return {
    data: state.response ? state.response.options : [],
    isDataLoading: state.isDataLoading,
    auth,
    error,
  };
};
